import { type Dispatch, useCallback } from 'react'
import type { LocationEditorActions } from '../types'

export function useClickAwayProps(dispatch: Dispatch<LocationEditorActions>) {
  const onClickAway = useCallback(() => {
    dispatch({ type: 'clickAway:click' })
  }, [dispatch])

  return {
    onClickAway,
  }
}
